import { AdvertisingContentType } from './adverts.enums';
import { AdExtensionType } from './types';
export function getAdvertisingContentType(adExtensions) {
    var shouldDisableCommercialOverlay = adExtensions.some(function(ext) {
        return ext.type === AdExtensionType.FreeWheel && ext.parameters.some(function(param) {
            var _param_name;
            return ((_param_name = param.name) === null || _param_name === void 0 ? void 0 : _param_name.toLowerCase()) === 'ad_type' && 'non_commercial_disable_overlay' === param.value;
        });
    });
    return shouldDisableCommercialOverlay ? AdvertisingContentType.Other : AdvertisingContentType.Advert;
}

//# sourceMappingURL=advert-content-type.js.map